module.exports = __webpack_public_path__ + "img/easter_egg_modal_next_bg.954d8255.png";